module.exports = __webpack_public_path__ + "img/54.bb7eb49f.svg";